import colors from 'config/theme/colors';
import { createDictionary } from 'utils/ObjectUtils';

export const TireSeverityEnum = {
  UNDEFINED: 'UNDEFINED',
  HIGH: 'HIGH',
  LOW: 'LOW',
  NONE: 'NONE'
};
export type TireSeverityEnum = (typeof TireSeverityEnum)[keyof typeof TireSeverityEnum];

export const TireSeasonEnum = {
  ALL_SEASON: 'ALL_SEASON',
  SUMMER: 'SUMMER',
  UNSPECIFIED: 'UNSPECIFIED',
  WINTER: 'WINTER'
};
export type TireSeasonEnum = (typeof TireSeasonEnum)[keyof typeof TireSeasonEnum];

export const TirePositionEnum = {
  FRONT_LEFT: 'FRONT_LEFT',
  FRONT_RIGHT: 'FRONT_RIGHT',
  REAR_RIGHT: 'REAR_RIGHT',
  REAR_LEFT: 'REAR_LEFT'
};
export type TirePositionEnum = (typeof TirePositionEnum)[keyof typeof TirePositionEnum];

export const SEVERITY_ORDER = [
  TireSeverityEnum.UNDEFINED,
  TireSeverityEnum.NONE,
  TireSeverityEnum.LOW,
  TireSeverityEnum.HIGH
];

export const SEVERITY_STYLE = createDictionary(
  {
    [TireSeverityEnum.HIGH]: { icon: 'fb-icon--status-urgent', color: colors['@error-color'] },
    [TireSeverityEnum.NONE]: { icon: 'fb-icon--status-check-circle', color: colors['@success-color'] },
    [TireSeverityEnum.LOW]: { icon: 'fb-icon--status-recommended', color: colors['@warning-color-light'] }
  },
  { icon: 'fb-icon--empty', color: colors['@grey-20'] }
);
